const alertUpstreamDefaultState = {
    data: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const alertUpstreamReducer = (state = alertUpstreamDefaultState, action) => {
    switch(action.type) {
        case 'START_GET_ALERT_UPSTREAM':
            return {
                ...state,
                data: {},
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ALERT_UPSTREAM_SUCCESS':
            return {
                ...state,
                data: action.alertUpstream,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_ALERT_UPSTREAM_SUCCESS':
        return {
            data: action.alertUpstream,
            loading: false,
            success: true,
            error: false,
            errorMessage: null,
            successMessage: 'Upstream Alert has been updated',
        };
        case 'START_ALERT_UPSTREAM_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_ALERT_UPSTREAM_SUCCESS':
            return {
                ...state,
                data: action.alertUpstream,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Alert News has been updated',
            };
        case 'START_REMOVE_ALERT_UPSTREAMS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_ALERT_UPSTREAMS_SUCCESS':
            return {
                ...state,
                data: state.data.filter(ad => { // check original posts and only include posts that don't have that to delete ID
                    return !action.adIds.includes(ad.id); // includes is checking inside an array of numbers to see if any match
                }),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your ads have been removed!',
            };
        case 'ALERT_UPSTREAMS_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default alertUpstreamReducer;